import _reducer from './reducer';
import TaskStatistic from './model';
import * as _actions from './actions';

export default TaskStatistic;
export const reducer = _reducer;
export const actions = _actions;



// WEBPACK FOOTER //
// ./data/Tasks/TaskStatistic/index.js